import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromPnrLocatorFlow from './pnr-locator-flow.reducer';

export const selectPnrLocatorFlow = createFeatureSelector<fromPnrLocatorFlow.PnrLocatorFlowState>('pnrLocatorFlow');

export const selectLookupMethod = createSelector(
  selectPnrLocatorFlow,
  (pnrLocatorFlowState) => pnrLocatorFlowState.lookupMethod
);
